module.exports = __webpack_public_path__ + "static/media/verified-icon.7c8e5c56.svg";